import { render, staticRenderFns } from "./exhibitor-detail.vue?vue&type=template&id=1155758c&scoped=true"
import script from "./exhibitor-detail.vue?vue&type=script&lang=js"
export * from "./exhibitor-detail.vue?vue&type=script&lang=js"
import style0 from "./exhibitor-detail.vue?vue&type=style&index=0&id=1155758c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1155758c",
  null
  
)

export default component.exports